import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowRight, Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="h-screen w-screen overflow-hidden bg-white grid place-items-center px-6"
      data-testid="login-page"
    >
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-10">
          <span className="grid place-items-center w-8 h-8 border border-black bg-[#0A0A0A] text-white">
            <Lock size={14} strokeWidth={2} />
          </span>
          <span className="font-display text-xs font-bold uppercase tracking-[0.24em]">
            Admin · Adi / Notes
          </span>
        </div>

        <h1 className="font-display font-black text-4xl tracking-[-0.03em] leading-[0.95] mb-2">
          Sign in to publish.
        </h1>
        <p className="text-zinc-500 text-sm mb-10">
          Use your owner credentials to access the editor.
        </p>

        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email"
            className="w-full px-4 py-3 text-sm border border-black/90 outline-none focus:border-[#002FA7] transition-colors"
          />
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
            className="w-full px-4 py-3 text-sm border border-black/90 outline-none focus:border-[#002FA7] transition-colors"
          />
          {error && (
            <p
              data-testid="login-error"
              className="text-[#FF2A00] text-xs font-medium"
            >
              {error}
            </p>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-[#0A0A0A] text-white font-display text-xs font-bold uppercase tracking-[0.22em] hover:bg-[#002FA7] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
            <ArrowRight size={14} strokeWidth={2.5} />
          </button>
        </form>

        <a
          href="/"
          className="block mt-8 font-display text-[11px] uppercase tracking-[0.2em] text-zinc-400 hover:text-black transition-colors"
        >
          ← Back to home
        </a>
      </div>
    </div>
  );
}
